import { BbContentPresenterContext } from '@Components/BigBrowse/bb2/BbContentPresenter';
import { useBbQueueManager } from '@Components/BigBrowse/bb2/BbQueueManager';
import { BbScreenContent } from '@Components/BigBrowse/bb2/BbScreenContent';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';

import { useFocusManager } from './useFocusManager';

import { useFloorsStore2 } from '~stores/floors-list';
import { useNavigationStore } from '~stores/navigation';
import type { RootStackParamList, RouteNames } from '~types/navigation';
type ScreenProps = NativeStackScreenProps<
  RootStackParamList,
  RouteNames.BigBrowse
>;

type Props = ScreenProps & object;

export const BigBrowseScreen = observer(function BigBrowseScreen({
  navigation,
  route,
}: Props) {
  const { navigatorReady, setNavigation } = useNavigationStore();
  setNavigation(navigation);

  const { params, key } = route;

  const { getContentPresenter, handleEmptyJourneyParam } = useBbQueueManager();

  const [contentPresenter] = useState(() => getContentPresenter(params, key));
  const { onRefocus, onBlur, onFocus } = contentPresenter;

  const { defaultFloorId } = useFloorsStore2();

  useFocusManager({
    onRefocus,
    onFocus,
    onBlur,
  });

  useEffect(() => {
    const { routes } = navigation.getState();
    const { journey } = route.params;

    if (routes.length > 1 && journey === 'floor') {
      contentPresenter.hidePlane().then();
    }

    return () => {
      contentPresenter.destroy();
    };
  }, []);

  if (!navigatorReady.value) {
    return null;
  }
  if (!defaultFloorId.value) {
    return null;
  }

  if (!route.params.journeyParam) {
    handleEmptyJourneyParam(defaultFloorId.value);
  }

  return (
    <BbContentPresenterContext.Provider value={contentPresenter}>
      <BbScreenContent />
    </BbContentPresenterContext.Provider>
  );
});
